import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function NetworkErrorIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M9.8999 7.50003C7.51974 7.89721 5.23627 9.01397 3.3999 10.8503L4.81412 12.2646C6.25912 10.8196 8.03633 9.90922 9.8999 9.53357V7.50003Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M9.8999 11.5846C8.55464 11.9278 7.28125 12.6259 6.22833 13.6788L7.64254 15.093C8.30145 14.4341 9.07549 13.9605 9.8999 13.6721V11.5846Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M13.8999 13.6825V11.5922C15.2343 11.938 16.4968 12.6335 17.542 13.6788L16.1278 15.093C15.4768 14.4419 14.7133 13.9718 13.8999 13.6825Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M13.8999 9.53955V7.50498C16.2695 7.90643 18.5417 9.02155 20.3705 10.8503L18.9563 12.2646C17.5189 10.8272 15.7527 9.91882 13.8999 9.53955Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M13.3999 17C13.3999 17.8284 12.7283 18.5 11.8999 18.5C11.0715 18.5 10.3999 17.8284 10.3999 17C10.3999 16.1716 11.0715 15.5 11.8999 15.5C12.7283 15.5 13.3999 16.1716 13.3999 17Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M10.8999 14H12.8999V6H10.8999V14Z",
    fill: "currentColor"
  }));
}